export const Page = "Page";
export const PageLeftHead = `${Page}__LeftHead`;
export const PageLeftBody = `${Page}__LeftBody`;
export const PageMainHead = `${Page}__MainHead`;
export const PageMainHeadLightBlue = `${PageMainHead}--lightBlue`;
export const PageMainBody = `${Page}__MainBody`;
export const PageMain = `${Page}__Main`;
